module.exports = __webpack_public_path__ + "media/img/before_buy_image_1-8e024369.png";